import Icon from '../components/Icon.vue'

Icon.register({
  'skull-crossbones': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M439.1 453.1L297.2 384 439.2 314.9C447.1 311 450.3 301.4 446.3 293.5L432 264.9C428.1 256.9 418.4 253.7 410.5 257.7L224 348.4 37.5 257.7C29.6 253.7 20 256.9 16 264.9L1.7 293.5C-2.3 301.4 0.9 311 8.8 314.9L150.8 384 8.8 453.1C0.9 457-2.3 466.6 1.7 474.5L16 503.2C20 511.1 29.6 514.3 37.5 510.3L224 419.6 410.5 510.3C418.4 514.3 428 511.1 432 503.2L446.3 474.5C450.3 466.6 447.1 457 439.1 453.1zM150 237.3L144.5 263.1C141.8 275.8 149.9 288 161 288H287.1C298.1 288 306.2 275.8 303.5 263.1L298 237.3C339.8 214.9 368 174.5 368 128 368 57.3 303.5 0 224 0S80 57.3 80 128C80 174.5 108.2 214.9 150 237.3zM280 112C297.6 112 312 126.4 312 144S297.6 176 280 176 248 161.6 248 144 262.4 112 280 112zM168 112C185.7 112 200 126.4 200 144S185.7 176 168 176 136 161.6 136 144 150.3 112 168 112z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/skull-crossbones.js
// module id = FeVn
// module chunks = 144